import { useTranslation } from 'react-i18next';

import EmbeddedFormPage from './EmbeddedFormPage';

const SubstituteTeachersPage = () => {
  const { t } = useTranslation();

  return (
    <EmbeddedFormPage
      titleKey="substituteTeachers.pageTitle"
      description={t('substituteTeachers.description')}
      formUrl="https://wonderschool.fillout.com/t/bdRMkqkrZ8us"
    />
  );
};

export default SubstituteTeachersPage;
